/**
 * Represents operation hours for a single day
 */
export interface DayOperationHours {
  /**
   * Opening time in HH:MM format (24-hour)
   */
  open_time: string;

  /**
   * Closing time in HH:MM format (24-hour)
   */
  close_time: string;
}

/**
 * Weekly operation schedule with days as keys
 * API format for creating/updating locations
 */
export interface OperatingHours {
  monday?: DayOperationHours;
  tuesday?: DayOperationHours;
  wednesday?: DayOperationHours;
  thursday?: DayOperationHours;
  friday?: DayOperationHours;
  saturday?: DayOperationHours;
  sunday?: DayOperationHours;
}

/**
 * Backend schedule structure returned by Django API
 * This is the raw format when include_schedules=true is passed
 */
export interface BackendSchedule {
  id: number;
  location: {
    external_id: string;
    display_name: string;
    id: number;
    name: string;
    type?: {
      id: number;
      external_id: string;
      name: string;
    };
    parent_id: number | null;
    properties: any;
    params: any;
    zone_type: string | null;
  };
  day_of_week: number;
  day_of_week_display: string;
  open_time: string;
  close_time: string;
  is_closed: boolean;
  created: string;
  modified: string;
  created_by: any;
  modified_by: any;
  created_timestamp: number;
  modified_timestamp: number;
}
